import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import UserApiManager from '../../api/services/UserApiManager'
import { useTranslation } from 'react-i18next'

function UserChangePassword() {
    const { t } = useTranslation()
    const [validated, setValidated] = useState(false)
    const [currentPassword, setCurrentPassword] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false || password !== confirmPassword) {
            event.preventDefault()
            event.stopPropagation()
            setValidated(true)
            return
        }
        event.preventDefault()
        setValidated(true)

        const data = {
            pass: [{ value: password, existing: currentPassword }],
        }

        var result = await UserApiManager.editUser(data)

        if (result) {
            toast.success(t('alerts.change_password_success'), {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
            setTimeout(() => {
                localStorage.clear()
                navigate('/user-pages/login')
            }, 2000)
        } else {
            toast.error(t('alerts.change_password_error'), {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
    }

    return (
        <div className="col-12 grid-margin stretch-card">
            <ToastContainer />
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">{t('change_pass_title')}</h4>
                    <p className="card-description">{t('change_pass_description')}</p>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                    >
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom01"
                        >
                            <Form.Label>{t('current_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                className="form-control"
                                name="currentPassword"
                                value={currentPassword}
                                required
                                onChange={(e) =>
                                    setCurrentPassword(e.target.value)
                                }
                                placeholder={t('password_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom02"
                        >
                            <Form.Label>{t('new_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                className="form-control"
                                name="password"
                                value={password}
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={t('password_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom03"
                        >
                            <Form.Label>{t('confirm_password')}</Form.Label>
                            <Form.Control
                                type="password"
                                className="form-control"
                                name="confirmPassword"
                                required
                                value={confirmPassword}
                                onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                }
                                placeholder={t('password_placeholder')}
                                isInvalid={
                                    validated && confirmPassword !== password
                                }
                                isValid={
                                    validated && confirmPassword === password
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                {t('passwords_do_not_match')}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Button
                            variant="btn btn-primary"
                            className="me-2"
                            type="submit"
                        >
                            {t('button.save')}
                        </Button>
                        <Button
                            variant="btn btn-light"
                            onClick={() => navigate(-1)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default UserChangePassword
